import { CloseScrollStrategy, Overlay } from '@angular/cdk/overlay';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MAT_AUTOCOMPLETE_SCROLL_STRATEGY, MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CoreLibModule } from '@fitech-workspace/core-lib';
import { ColorPickerModule } from 'ngx-color-picker';
import { AutocompleteMdComponent } from './components/autocomplete-md/autocomplete-md.component';
import { DynamicFormComponent } from './components/dynamic-form/dynamic-form.component';
import { DynamicFormArrayComponent } from './components/dynamic-form-array/dynamic-form-array.component';
import { DynamicFormCheckboxInputComponent } from './components/dynamic-form-checkbox-input/dynamic-form-checkbox-input.component';
import { DynamicFormColorPickerComponent } from './components/dynamic-form-color-picker/dynamic-form-color-picker.component';
import { DynamicFormFileUploaderComponent } from './components/dynamic-form-file-uploader/dynamic-form-file-uploader.component';
import { DynamicFormInputComponent } from './components/dynamic-form-input/dynamic-form-input.component';
import { DynamicFormMultiDropdownInputComponent } from './components/dynamic-form-multi-dropdown-input/dynamic-form-multi-dropdown-input.component';
import { DynamicFormSelectInputComponent } from './components/dynamic-form-select-input/dynamic-form-select-input.component';
import { DynamicFormSwitchInputComponent } from './components/dynamic-form-switch/dynamic-form-switch-input.component';
import { MatSelectExtendedComponent } from './components/mat-select-extended/mat-select-extended.component';
import { MatSelectSearchComponent } from './components/mat-select-search/mat-select-search.component';
import { DisableControlDirective } from './directives/disable-control.directive';
import { MatSelectSearchOptionDirective } from './directives/mat-select-search-option.directive';

export function scrollFactory(overlay: Overlay): () => CloseScrollStrategy {
	return () => overlay.scrollStrategies.close();
}

@NgModule({
	declarations: [
		AutocompleteMdComponent,
		DynamicFormComponent,
		DynamicFormInputComponent,
		DynamicFormSelectInputComponent,
		DynamicFormMultiDropdownInputComponent,
		DynamicFormCheckboxInputComponent,
		DynamicFormFileUploaderComponent,
		DynamicFormColorPickerComponent,
		DynamicFormSwitchInputComponent,
		MatSelectSearchComponent,
		MatSelectSearchOptionDirective,
		MatSelectExtendedComponent,
		DisableControlDirective,
		DynamicFormArrayComponent,
	],
	imports: [CommonModule, CoreLibModule, MatAutocompleteModule, MatFormFieldModule, ColorPickerModule, ScrollingModule],
	exports: [
		AutocompleteMdComponent,
		DynamicFormComponent,
		DynamicFormInputComponent,
		DynamicFormSelectInputComponent,
		DynamicFormMultiDropdownInputComponent,
		DynamicFormCheckboxInputComponent,
		DynamicFormFileUploaderComponent,
		MatSelectSearchComponent,
		MatSelectSearchOptionDirective,
		MatSelectExtendedComponent,
		DisableControlDirective,
		DynamicFormArrayComponent,
	],
	providers: [
		{
			provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
			useFactory: scrollFactory,
			deps: [Overlay],
		},
	],
})
export class SharedUiInputsMdModule {}
